// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Assign Invoice Booklet'" tab="true"></sub-header>

  <form name="\$ctrl.form">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Start series</td>
        <td>
          <input
            disabled
            required
            ng-model="\$ctrl.booklet.startSeries"
            type="number"
            min="1">
        </td>
      </tr>
      <tr>
        <td></td>
        <td>End series</td>
        <td>
          <input
            disabled
            required
            ng-model="\$ctrl.booklet.endSeries"
            type="number"
            min="1">
        </td>
      </tr>
      <tr>
        <td></td>
        <td>User</td>
        <td>
          <select
            required
            ng-model="\$ctrl.selectedUser"
            ng-options="u as u.fullName for u in \$ctrl.users">
          </select>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        command-access="AssignOfficialReceiptBooklet"
        ng-click="\$ctrl.assign()"
        ng-disabled="\$ctrl.form.\$invalid">
        Assign
      </button>
    </div>
  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/official-receipt-booklet/assign/official-receipt-booklet-assign.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;